import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../commons/services/auth.service';

export interface DiaServicio {
  Completo: boolean | string;
  Dia: string;
  HoraFin: string;
  HoraInicio: string;
  Laborable: boolean | string;
}

export interface ServicioItem {
  kIdOperServicio: number;
  fCatTipoOrganismoId: number;
  fCatOrganismoId: number;
  sConfiguracion: string;
  fFechaAlta: string;
  fFechaCambio: string;
  fFechaBaja: string | null;
  bEstatus: boolean;
}

export interface Organo {
  courtId: number;
  courtName: string;
}

export interface TipoOrgano {
  catTipoOrganismoId: number;
  nombre: string;
}

interface ServicioResponse {
  succcess: boolean;
  data: ServicioItem[];
  message?: string;
}

interface OrganoResponse {
  succcess: boolean;
  data: Organo[];
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ServicioService {
  private readonly baseUrl = `${environment.apiBaseUrl}${environment.gateway}/icoij/servicio`;
  private http: HttpClient = inject(HttpClient);
  private authService: AuthService = inject(AuthService);


  /**
   * Obtiene los servicios para un organismo específico
   * @param fCatOrganismoId 
   * @returns 
   */
  obtenerServicios(fCatOrganismoId?: number | null): Observable<ServicioItem[]> {
    const tipoOrganismoId = this.getIdTypeCourt();
    const url =
      fCatOrganismoId === null || fCatOrganismoId === undefined
        ? `${this.baseUrl}?fCatTipoOrganismoId=${tipoOrganismoId}`
        : `${this.baseUrl}?fCatOrganismoId=${fCatOrganismoId}&fCatTipoOrganismoId=${tipoOrganismoId}`;

    return this.http
      .get<ServicioResponse>(url)
      .pipe(map((resp) => resp?.data ?? []));
  }

  /**
   * Obtiene los órganos
   * @returns 
   */

  obtenerOrganos(): Observable<Organo[]> {
    const organosUrl = `${environment.apiBaseUrl}${environment.gateway}/icoij/getCourtsIJ/${this.getIdTypeCourt()}`;
    return this.http
      .get<OrganoResponse>(organosUrl)
      .pipe(map((resp) => resp?.data ?? []));
  }

  /**
   * Guarda los días de servicio para un organismo específico
   * @param fCatOrganismoId 
   * @param tipoOrganismoId 
   * @param dias 
   * @returns 
   */
  guardarDias(
    fCatOrganismoId: number,
    tipoOrganismoId: number = this.getIdTypeCourt(),
    dias: DiaServicio[]
  ): Observable<any> {
    const payload = {
      diasServicio: dias.map((dia) => ({
        Dia: dia.Dia,
        Completo: String(dia.Completo),
        HoraInicio: dia.HoraInicio,
        HoraFin: dia.HoraFin,
        Laborable: String(dia.Laborable),
      })),
    };
    const url = `${this.baseUrl}/${fCatOrganismoId}?fCatTipoOrganismoId=${tipoOrganismoId}`;
    return this.http.post(url, payload);
  }

  /**
   * Desactiva un servicio específico
   * @param servicioId 
   * @returns 
   */
  desactivar(servicioId: number): Observable<any> {
    const url = `${this.baseUrl}/${servicioId}/desactivar`;
    return this.http.put(url, {});
  }

  private getIdTypeCourt(): number {
    return this.authService.getIdTypeCourt() ?? 0;
  }


}
